export default __webpack_public_path__ + "static/media/phone.4d2f6596.jpg";